import { render, staticRenderFns } from "./BerkleyNatureOfBusinessSelect.vue?vue&type=template&id=19fc5837"
import script from "./BerkleyNatureOfBusinessSelect.vue?vue&type=script&lang=js"
export * from "./BerkleyNatureOfBusinessSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports